import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const getInitial = () => {
  if (typeof window === "undefined") return "fr";
  return localStorage.getItem("gc_lang") || "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("gc_lang", l); } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
